import { CALL_API, Schemas } from '../../../common/middleware/api';
import globalize from '../../../common/services/globalize';

export const KINDERGARTEN_MONTHLY_REPORT_REQUEST = 'KINDERGARTEN_MONTHLY_REPORT_REQUEST';
export const KINDERGARTEN_MONTHLY_REPORT_SUCCESS = 'KINDERGARTEN_MONTHLY_REPORT_SUCCESS';
export const KINDERGARTEN_MONTHLY_REPORT_FAILURE = 'KINDERGARTEN_MONTHLY_REPORT_FAILURE';

export const KINDERGARTEN_REPORT_EXPORT_REQUEST = 'KINDERGARTEN_REPORT_EXPORT_REQUEST';
export const KINDERGARTEN_REPORT_EXPORT_SUCCESS = 'KINDERGARTEN_REPORT_EXPORT_SUCCESS';
export const KINDERGARTEN_REPORT_EXPORT_FAILURE = 'KINDERGARTEN_REPORT_EXPORT_FAILURE';

export const loadKindergartenMonthlyReport = (options) => ({
	[CALL_API]: {
		types: [KINDERGARTEN_MONTHLY_REPORT_REQUEST, KINDERGARTEN_MONTHLY_REPORT_SUCCESS, KINDERGARTEN_MONTHLY_REPORT_FAILURE],
		endpoint: `api/reports/kindergarten/monthly`,
		request: options,
		schema: Schemas.KINDERGARTEN_MONTHLY_REPORT_ARRAY
	}
});

export const exportKindergartenPayments = (options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [KINDERGARTEN_REPORT_EXPORT_REQUEST, KINDERGARTEN_REPORT_EXPORT_SUCCESS, KINDERGARTEN_REPORT_EXPORT_FAILURE],
			endpoint: `api/reports/kindergarten/monthly/export`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			schema: Schemas.KINDERGARTEN_MONTHLY_REPORT_ARRAY,
			onSuccessEvent
		},
		format: 'Excel',
		filename: () => `KindergartenReport-${options.month}-${options.year}.xlsx`
	});
}